import { render, staticRenderFns } from "./SearchResult.vue?vue&type=template&id=5e8e31c8&scoped=true"
import script from "./SearchResult.vue?vue&type=script&lang=ts"
export * from "./SearchResult.vue?vue&type=script&lang=ts"
import style0 from "./SearchResult.vue?vue&type=style&index=0&id=5e8e31c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8e31c8",
  null
  
)

export default component.exports